import { Constructor } from '@skylab-shared/types';
import { BusinessObjectBase } from './../../bo';
import { ModelBase } from './../../model';
import { RepositoryBase, RepositoryConfig } from './repository-base';

declare type RepositoryConstructor<TBO extends BusinessObjectBase<TModel>, TModel extends ModelBase, TGetDTO, TUpdateDTO> = Constructor<RepositoryBase<TBO, TModel, TGetDTO, TUpdateDTO>>;
declare type RepositoryDecorator<TBO extends BusinessObjectBase<TModel>, TModel extends ModelBase, TGetDTO, TUpdateDTO> = (target: RepositoryConstructor<TBO, TModel, TGetDTO, TUpdateDTO>) => void;

export function Repository<TBO extends BusinessObjectBase<TModel>, TModel extends ModelBase, TGetDTO, TUpdateDTO>(config: RepositoryConfig<TGetDTO, TUpdateDTO>): RepositoryDecorator<TBO, TModel, TGetDTO, TUpdateDTO> {
    return target => {
        Reflect.defineMetadata('skl:data-source', config, target);
    };
}
